<template>
    <reset-password
            :hash="$route.params.hash"
            :userId="parseInt($route.params.userId)"
            :resetPassword="resetPassword"
            :validateToken="validateToken"
            @success="success()"
            @failedToResetPassword="$store.dispatch('alert/error', $event.data.status)"
            @tokenNotFound="tokenNotFound()"
    />
</template>
<script>
    import ResetPassword from "../../core/Components/User/ResetPassword";

    export default {
        components: {
            ResetPassword
        },
        methods: {
            success() {
                this.$store.dispatch('alert/success', 'Password was changed');
                this.$router.push({name: 'login'})
            },
            resetPassword(data) {
                return this.$store.dispatch('account/resetPassword', data);
            },
            validateToken(data) {
                return this.$store.dispatch('account/validateToken', data);
            },
            tokenNotFound() {
                this.$store.dispatch('alert/error', 'Your reset link is invalid.');
                this.$router.push({name: 'login'});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/public/ResetPassword.vue